import React from 'react'
import { injectIntl, InjectedIntlProps, Link } from 'gatsby-plugin-intl'
import { Picture } from 'react-responsive-picture'

type Props = InjectedIntlProps

const sections = ['business', 'technical', 'partner']

const faqMenu = ({ intl: { formatMessage } }: Props) => {
  return (
    <ul className="faq-menu">
      {sections.map(section => (
        <li key={`fqm-${section}`}>
          <Picture
            sources={[
              {
                srcSet: `/images/icons/${section}-circle.png 1x, /images/icons/${section}-circle@2x.png 2x`,
                type: 'image/jpeg',
              },
            ]}
          />
          <Link to={`/faq/${section}`}>{formatMessage({ id: `faq.${section}.title` })}</Link>
        </li>
      ))}
    </ul>
  )
}

export default injectIntl(faqMenu)
